import { request } from './client.js';
import type { SessionUser } from '../state/session.js';

export interface AuthBundle {
  user: SessionUser;
  accessToken: string;
  refreshToken: string;
}

export interface LoginInput {
  email: string;
  password: string;
}

export interface RegisterInput {
  name: string;
  email: string;
  phone: string;
  password: string;
}

export function login(input: LoginInput): Promise<AuthBundle> {
  return request<AuthBundle>('/auth/login', { method: 'POST', body: input, auth: false });
}

export function register(input: RegisterInput): Promise<AuthBundle> {
  return request<AuthBundle>('/auth/register', {
    method: 'POST',
    body: { ...input, role: 'rider' },
    auth: false,
  });
}

export function logout(refreshToken: string): Promise<{ ok: boolean }> {
  return request('/auth/logout', { method: 'POST', body: { refreshToken } });
}

export function me(): Promise<SessionUser> {
  return request<SessionUser>('/auth/me');
}
